































































import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    title: { required: false, type: String },
    width: { type: String },
    disableButtons: { type: Boolean, default: false },
  },
});
